import { render, staticRenderFns } from "./positionList.vue?vue&type=template&id=71becbcc&scoped=true&"
import script from "./positionList.vue?vue&type=script&lang=js&"
export * from "./positionList.vue?vue&type=script&lang=js&"
import style0 from "./positionList.vue?vue&type=style&index=0&id=71becbcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71becbcc",
  null
  
)

export default component.exports